import React from "react";
import PresvalDropDown from "../PresvalDropDownView";
import {CatalogService} from "../../../service/catalog/CatalogService";


export default class UserDropDownContainer extends React.Component {
    constructor(props) {
        super(props);

        this.catalogService = new CatalogService();

        this.getCatalogUsers = this.getCatalogUsers.bind(this);

        this.state = {
            catUsersCatalog: [],
        };

        this.getCatalogUsers();
    }

    getCatalogUsers() {
        this.catalogService.getCatalogUsers()
            .then(
                users => {
                    this.setState({
                        catUsersCatalog: users,
                    });
                    this.props.loading(false);
                });
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catUsersCatalog}
            save={this.props.save}
            value={this.props.value}
            placeholder={this.props.placeholder}
            tabIndex={this.props.tabIndex}
            disabled={this.props.disabled}
        />
    }
};